var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutOfService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_7489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.393 74.5444L78.5443 65.3931L73.241 57.3096L76.4997 49.4356L85.9674 47.4701V34.5301L76.4997 32.5646L73.241 24.6907L78.5443 16.6071L69.393 7.45581L61.3094 12.7591L53.4355 9.50042L51.47 0.0327148H38.53L36.5645 9.50042L28.6905 12.7591L20.607 7.45581L11.4557 16.6071L16.759 24.6907L13.5003 32.5646L4.03259 34.5301V47.4701L13.5003 49.4356L16.759 57.3096L11.4557 65.3931L20.607 74.5444L28.6905 69.2411L36.5645 72.4998L38.53 81.9675H51.47L53.4355 72.4998L61.3094 69.2411L69.393 74.5444ZM29.1453 56.8548C20.3895 48.0989 20.3895 33.8974 29.1453 25.1415C37.9012 16.3857 52.1027 16.3857 60.8586 25.1415C69.6144 33.8974 69.6144 48.0989 60.8586 56.8548C52.1027 65.6106 37.9012 65.6106 29.1453 56.8548Z",
    fill: "url(#paint0_linear_491_7489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5835 51.5C60.9615 47.1221 62.1954 40.7905 60.2852 35.3211L52.3282 43.278C50.7542 44.852 48.2034 44.852 46.6294 43.278L42.7221 39.3707C41.1481 37.7967 41.1481 35.2459 42.7221 33.6719L50.6791 25.7149C45.2057 23.8087 38.8781 25.0426 34.5001 29.4205C29.8928 34.0278 28.7657 40.7905 31.1188 46.4537L26.8358 50.4006C27.777 52.2237 29.0109 53.9361 30.5375 55.4627C32.064 56.9892 33.7725 58.2231 35.5956 59.1643L39.5425 54.8813C45.2057 57.2384 51.9723 56.1073 56.5796 51.5039L56.5835 51.5Z",
    fill: "#7F23F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_7489",
    x: 0.0325928,
    y: 0.0327148,
    width: 89.9348,
    height: 89.9348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_7489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_7489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_7489",
    x1: 16.5,
    y1: 4.5,
    x2: 86,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutOfService);
export default __webpack_public_path__ + "static/media/icon_out_of_service.d20e8c30a6fe2591fcc794e9e5134c90.svg";
export { ForwardRef as ReactComponent };